import { render, staticRenderFns } from "./OrderHxScan.vue?vue&type=template&id=2f302a54&scoped=true&"
import script from "./OrderHxScan.vue?vue&type=script&lang=js&"
export * from "./OrderHxScan.vue?vue&type=script&lang=js&"
import style0 from "./OrderHxScan.vue?vue&type=style&index=0&id=2f302a54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f302a54",
  null
  
)

export default component.exports